import { Component, OnInit } from '@angular/core';

const NAVLINKS = [
  {title: 'Gange-regler', link:'/multiply-rules', content:'Læs lidt om reglerne for at gange.'},
  {title: 'Øv dine tabeller', link:'/multiply', content:'Hvis du kan dine tabeller, så er du ikke kun bedre hjulpet når du skal gange, men også når du skal dividere.'},
  {title: 'Gange-øvelser', link:'/multiply-exercises', content:'Brug dine tabeller på lidt større gange stykker. Du må gerne bruge papir og blyant.'}
];

@Component({
  selector: 'app-menu-multiply',
  templateUrl: './menu-multiply.component.html',
  styleUrls: ['./menu-multiply.component.css']
})
export class MenuMultiplyComponent implements OnInit {

  navLinks = NAVLINKS;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/menu-multiply/menu-multiply.component.ts